import type { ErrorEvent } from '@sentry/vue';

const STALE_DEPLOY_PRELOAD_ERROR_PREFIX = 'Unable to preload CSS for ';

export const dropStaleDeployPreloadErrors = (event: ErrorEvent): ErrorEvent | null => {
	const isStaleDeployPreloadError = event.exception?.values?.some(
		(exception) => exception.value?.startsWith(STALE_DEPLOY_PRELOAD_ERROR_PREFIX) === true,
	);
	return isStaleDeployPreloadError === true ? null : event;
};
